import { render } from "./pc_wechat_official_account.vue?vue&type=template&id=7060cd5a"
import script from "./pc_wechat_official_account.vue?vue&type=script&lang=js"
export * from "./pc_wechat_official_account.vue?vue&type=script&lang=js"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__